import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import "modules/DealerDocumentations/components/AddEditDealerDocumentationModal/components/ImagePreview/ImagePreview.scss";
import { getNameFromURL } from "utils/common";

import type { ReactNode } from "react";

type ImagePreviewProps = {
  children: ReactNode;
  url?: string;
};

export const ImagePreview = ({ url, children }: ImagePreviewProps) => {
  const { t } = useTranslation();
  if (!url) return null;

  const fileName = getNameFromURL(url);

  return (
    <div className="file-uploaded">
      <div className="status-message">
        <span>{t("v8_file_uploaded", "File uploaded")} </span>
      </div>
      <div className="image-url-delete">
        <div className="image-preview-wrapper">
          <Icon className="image" />
          <a href={url} target="_blank" rel="noreferrer">
            {fileName}
          </a>
        </div>
        {children}
      </div>
    </div>
  );
};
